import { Radio } from 'antd';
import React, { useState } from 'react';
import { BsGraphUp, BsPeople } from 'react-icons/bs';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './ProfileEarnStatsComponent.styles.scss';

const ProfileEarnStatsComponent = ({
  followers,
}) => {
  const [selVal, setSelVal]= useState('instagram');
  const optionsWithDisabled = [
    { label: 'Instagram', value: 'instagram' },
    { label: 'Youtube', value: 'youtube', disabled: true },
    { label: 'Twitter', value: 'twitter', disabled: true },
  ];
  const onChangePlatform = (e) =>{
    setSelVal(e.target.value);
  };
  return (
    <div className="col-md-6 my-3 px-2">
      <div className="common_card p-3 profile_stats_card h-100">
        <div className="profile_stats_card_top">
          <div className="d-flex justify-content-between">
            <h4 className="profile_stats_card_top--title">Earning Potential</h4>
            <div className="profile_stats_card_toggles">
              <Radio.Group
                options={optionsWithDisabled}
                onChange={onChangePlatform}
                value={selVal}
                optionType="button"
                buttonStyle="solid"
              />
            </div>
          </div>
        </div>
        <div className="profile_stats_card_middle py-4">
          {/* <p className="profile_stats_card_middle--subtitle m-0" style={{opacity:0}}>Avg. Earning per post</p> */}
          {/* <div className="profile_stats_card_middle--costrange" style={{opacity:0}}>{CurrencyIcon()} 500 <span>to</span> 2000</div> */}
        </div>
        <div className="profile_stats_card_bottom">
          <div className="d-flex justify-content-between">
            <div className="profile_stats_card_bottom_left">
              <p className="profile_stats_card_middle--subtitle m-0">Historic Engagement Rate</p>
              <div className="profile_stats_card_middle--costrange"><BsGraphUp size={16}
                color={'#777'}/> N/A</div>
            </div>
            <div className="profile_stats_card_bottom_right">
              <p className="profile_stats_card_middle--subtitle m-0">Total Followers</p>
              <div className="profile_stats_card_middle--costrange"><BsPeople size={16}
                color={'#777'}/> {followers || 0}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileEarnStatsComponent;
